"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SortDirection_1 = require("./model/SortDirection");
class AbstractGridDataManager {
    constructor() {
        this.data = [];
        this.sortedByColumn = -1;
        this.sortDirection = SortDirection_1.SortDirection.ASCENDING;
    }
    sort(column, sortDirection, callDataChanged) {
        // Implementation left empty (to satisfy TSLint), interface method implemented to satisfy TS
    }
    setGrid(grid) {
        this.grid = grid;
    }
    getDataRows() {
        return this.data;
    }
    getDataRow(row) {
        if (row >= 0 && row < this.data.length) {
            return this.data[row];
        }
        return null;
    }
    getSortDirection() {
        return this.sortDirection;
    }
    setSortedByColumn(column, sortDirection) {
        this.sortedByColumn = column;
        this.sortDirection = sortDirection;
    }
    getSortedByColumn() {
        return this.sortedByColumn;
    }
    getNumberOfRows() {
        return this.data.length;
    }
    setData(data) {
        // Implementation left empty (to satisfy TSLint), interface method implemented to satisfy TS
    }
    clear() {
        // Implementation left empty (to satisfy TSLint), interface method implemented to satisfy TS
    }
}
exports.default = AbstractGridDataManager;
//# sourceMappingURL=AbstractGridDataManager.js.map